import Service from './Service';

class PartnerDataByTaxNumber extends Service {
    loadCompanyPartnerDataByTaxNumber(taxNumber) {
        return this.get('partner-data-by-tax-number?', { taxnumber: taxNumber });
    }

    loadNaturalPersonDataByTaxNumber(taxNumber) {
        return this.get('egyeni-vallalkozo-data-by-tax-number?', { taxnumber: taxNumber });
    }
}

export default new PartnerDataByTaxNumber('/ugyfel/');
